import React, { Fragment, useState } from "react";
import { Link } from "gatsby";
import { CalendarCheck, BriefcaseMedical, MapPin } from "lucide-react";

export const StickyBtns = () => {
  const [show, setShow] = useState(false);
  return (
    <Fragment>
      <a
        href={"https://drmohansdiabetes.co.in/enroll/?campname=website"}
        target="_blank"
        rel="noreferrer"
        className="fixed-banner-btn text-5 ff-1 fixed-book-appointment-link px-3 py-1 text-white"
      >
        <CalendarCheck className="me-2" />
        Book an Appointment
      </a>
      <Link
        to={"/doctors"}
        className="fixed-banner-btn text-5 ff-1 fixed-doctors-link-btn px-3 py-1 text-white"
      >
        <BriefcaseMedical className="me-2" />
        Doctors
      </Link>
      <button
        type="button"
        className="fixed-banner-btn text-5 ff-1 fixed-locations-btn px-3 py-1 text-white"
        onClick={(e) => setShow((prevState) => !prevState)}
      >
        <MapPin className="me-2" />
        Locations
      </button>
      <a
        href={"https://drmohansdiabetes.co.in/enroll/?campname=website"}
        target="_blank"
        rel="noreferrer"
        className="text-decoration-none request-call-back-btn text-5 ff-1 p-2 text-white"
      >
        Request a call back
      </a>
      <div
        className="relative z-30"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
        style={show ? { display: "block" } : { display: "none" }}
      >
        <div
          className="fixed inset-0 bg-gray-500/75 transition-opacity"
          aria-hidden="true"
        ></div>
        <div className="fixed inset-0 z-30 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="shadow-xl relative transform overflow-hidden rounded-lg bg-white text-left transition-all sm:my-8 sm:w-full sm:max-w-2xl">
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="absolute right-0 top-0 pr-4 pt-4">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                    style={{ width: "24px", height: "24px" }}
                    onClick={(e) => setShow((prevState) => !prevState)}
                  >
                    <span className="b">Close</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                      className="nn"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18 18 6M6 6l12 12"
                      ></path>
                    </svg>
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left">
                    <h3
                      className="border-b border-solid border-gray-200 text-center font-futuraMd text-lg text-gray-900"
                      id="modal-title"
                    >
                      Our Diabetes Centers
                    </h3>
                    <div className="mt-2">
                      <ul className="flex flex-row flex-wrap">
                        <li className="w-full basis-full p-4 lg:w-1/3 lg:basis-1/3">
                          <Link
                            className="text-decoration-none text-5 ff-2 text-dark"
                            to="/diabetes-centre-locations/tamil-nadu"
                          >
                            Tamil Nadu
                          </Link>
                        </li>
                        <li className="w-full basis-full p-4 lg:w-1/3 lg:basis-1/3">
                          <Link
                            className="text-decoration-none text-5 ff-2 text-dark"
                            to="/diabetes-centre-locations/puducherry"
                          >
                            Puducherry
                          </Link>
                        </li>
                        <li className="w-full basis-full p-4 lg:w-1/3 lg:basis-1/3">
                          <Link
                            className="text-decoration-none text-5 ff-2 text-dark"
                            to="/diabetes-centre-locations/kerala"
                          >
                            Kerala
                          </Link>
                        </li>
                        <li className="w-full basis-full p-4 lg:w-1/3 lg:basis-1/3">
                          <Link
                            className="text-decoration-none text-5 ff-2 text-dark"
                            to="/diabetes-centre-locations/karnataka"
                          >
                            Karnataka
                          </Link>
                        </li>
                        <li className="w-full basis-full p-4 lg:w-1/3 lg:basis-1/3">
                          <Link
                            className="text-decoration-none text-5 ff-2 text-dark"
                            to="/diabetes-centre-locations/odisha"
                          >
                            Odisha
                          </Link>
                        </li>
                        <li className="w-full basis-full p-4 lg:w-1/3 lg:basis-1/3">
                          <Link
                            className="text-decoration-none text-5 ff-2 text-dark"
                            to="/diabetes-centre-locations/west-bengal"
                          >
                            West Bengal
                          </Link>
                        </li>
                        <li className="w-full basis-full p-4 lg:w-1/3 lg:basis-1/3">
                          <Link
                            className="text-decoration-none text-5 ff-2 text-dark"
                            to="/diabetes-centre-locations/telangana"
                          >
                            Telangana
                          </Link>
                        </li>
                        <li className="w-full basis-full p-4 lg:w-1/3 lg:basis-1/3">
                          <Link
                            className="text-decoration-none text-5 ff-2 text-dark"
                            to="/diabetes-centre-locations/andhra-pradesh"
                          >
                            Andhra Pradesh
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
